import "./ButtonCover.css";
import "../../index.css";
import PlayIcon from "../PlayIcon/PlayIcon";

const ButtonCover = ({
  children,
  onClick,
  mediaWrap,
  width,
  visible = true,
  bg = "bg-dark",
  boxShadow = null,
  playOverlay = false,
  class_Name
}) => {
  return (
    <div
      onClick={onClick}
      className={`button-cover ${bg && bg}  ${boxShadow && boxShadow} ${mediaWrap && mediaWrap} ${class_Name && class_Name}`}
      style={{ display: visible ? "inline-block" : "none", width: width ? width : "auto" }}
    >
      <div className="button-cover__content">
        {children}
        {playOverlay && (
            <div className="button-cover__play-overlay" aria-hidden="true">
              <PlayIcon />
            </div>
        )}
      </div>
    </div>
  );
};

export default ButtonCover;